import script from "./MenuList.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuList.vue?vue&type=script&setup=true&lang=js"

import "./MenuList.vue?vue&type=style&index=0&id=4bceb9f0&lang=scss"

const __exports__ = script;

export default __exports__